const lineArrowLeftRight = (fabricCanvas, fabric) => {
    fabricCanvas.selection = false

    let line = null
    let arrowHead1 = null
    let arrowHead2 = null
    let selectedEnd = null
    let mouseDown = false

    fabricCanvas.on('mouse:down', (o) => {
        if (!fabricCanvas.isDrawingLineArrowLeftRightMode) return
        if (fabricCanvas?.getActiveObject()) return
        mouseDown = true
        let pointer = fabricCanvas.getPointer(o.e)
        let linePath = `M ${pointer.x} ${pointer.y} L ${pointer.x} ${pointer.y}`

        line = new fabric.Path(linePath, {
            stroke: window.globalColor,
            strokeWidth: 2,
            originX: 'center',
            originY: 'center',
            hasControls: false,
            hasBorders: false,
            objectCaching: false,
            selectable: true
        })

        //  fabricCanvas.add(line);
        let arrowHeadPath = 'M 0 0 L 20 10 L 0 20 Z'

        arrowHead1 = new fabric.Path(arrowHeadPath, {
            label: 'arrow-line-both-side',
            fill: window.globalColor,
            stroke: '',
            strokeWidth: 0,
            originX: 'center',
            originY: 'center',
            hasControls: false,
            hasBorders: false,
            top: pointer.y,
            left: pointer.x,
            selectable: false
        })

        // fabricCanvas.add(arrowHead1);

        arrowHead2 = new fabric.Path(arrowHeadPath, {
            label: 'arrow-line-both-side',
            fill: window.globalColor,
            stroke: '',
            strokeWidth: 0,
            originX: 'center',
            originY: 'center',
            hasControls: false,
            hasBorders: false,
            top: pointer.y,
            left: pointer.x,
            angle: 180,
            selectable: false
        })

        if (line && arrowHead1 && arrowHead2) {
            fabricCanvas.add(line, arrowHead1, arrowHead2)
            fabricCanvas.requestRenderAll()
        }
    })

    fabricCanvas.on('mouse:move', (o) => {
        if (!mouseDown) return
        if (mouseDown === true) {
            let pointer = fabricCanvas.getPointer(o.e)

            line.path[1][1] = pointer.x
            line.path[1][2] = pointer.y
            line.setCoords()

            arrowHead1.left = line.path[0][1]
            arrowHead1.top = line.path[0][2]

            arrowHead2.left = line.path[1][1]
            arrowHead2.top = line.path[1][2]

            let angle = Math.atan2(
                line.path[1][2] - line.path[0][2],
                line.path[1][1] - line.path[0][1]
            )

            arrowHead2.angle = angle * (180 / Math.PI)
            arrowHead1.angle = (angle + Math.PI) * (180 / Math.PI)

            arrowHead1.setCoords()
            arrowHead2.setCoords()
            fabricCanvas.requestRenderAll()
        }
    })

    fabricCanvas.on('mouse:up', () => {
        if (mouseDown === true) {
            mouseDown = false
            if (
                line.path[0][1] !== line.path[1][1] ||
                line.path[0][2] !== line.path[1][2]
            ) {
                selectedEnd = null
                let updatedLinePath = line.path
                fabricCanvas.remove(line)

                line = new fabric.Path(updatedLinePath, {
                    label: 'arrow-line-both-side',
                    stroke: window.globalColor,
                    strokeWidth: 2,
                    originX: 'center',
                    originY: 'center',
                    hasControls: false,
                    hasBorders: false,
                    objectCaching: false,
                    selectable: true
                })

                fabricCanvas.add(line)
                fabricCanvas.bringToFront(arrowHead1)
                fabricCanvas.bringToFront(arrowHead2)

                // let objects = []
                // fabricCanvas.getObjects().forEach((o) => {
                //     if (o.label === 'arrow-line-both-side') {
                //         objects.push(o)
                //     }
                // })
                if (line && arrowHead1 && arrowHead2) {
                    const group = new fabric.Group(
                        [line, arrowHead1, arrowHead2],
                        {
                            selectable: true
                        }
                    )

                    fabricCanvas.add(group)
                    fabricCanvas.remove(line)
                    fabricCanvas.remove(arrowHead1)
                    fabricCanvas.remove(arrowHead2)
                }
            } else {
                fabricCanvas.remove(line, arrowHead1, arrowHead2)
            }
        }
    })
}

export default lineArrowLeftRight

//version-1
// const lineArrowLeftRight = (fabricCanvas, fabric) => {
//     console.log('FabricCanvas:', fabricCanvas);
//     fabricCanvas.selection = false;

//     let line = null;
//     let arrowHead1 = null;
//     let arrowHead2 = null;
//     let mouseDown = false;

//     fabricCanvas.on('mouse:down', (o) => {
//         if (!fabricCanvas.isDrawingLineArrowLeftRightMode) return;
//         mouseDown = true;
//         let pointer = fabricCanvas.getPointer(o.e);

//         line = new fabric.Line([pointer.x, pointer.y, pointer.x, pointer.y], {
//             stroke: 'red',
//             strokeWidth: 3,
//             hasControls: false,
//             hasBorders: false,
//             selectable: false,
//         });

//         arrowHead1 = new fabric.Triangle({
//             fill: 'red',
//             left: pointer.x,
//             top: pointer.y,
//             angle: 0,
//             originX: 'center',
//             originY: 'center',
//             width: 20,
//             height: 20,
//             selectable: false,
//         });

//         arrowHead2 = new fabric.Triangle({
//             fill: 'red',
//             left: pointer.x,
//             top: pointer.y,
//             angle: 180,
//             originX: 'center',
//             originY: 'center',
//             width: 20,
//             height: 20,
//             selectable: false,
//         });

//         fabricCanvas.add(line, arrowHead1, arrowHead2);
//     });

//     fabricCanvas.on('mouse:move', (o) => {
//         if (!mouseDown) return;
//         let pointer = fabricCanvas.getPointer(o.e);

//         line.set({ x2: pointer.x, y2: pointer.y });

//         const angle = Math.atan2(pointer.y - line.y1, pointer.x - line.x1) * 180 / Math.PI;

//         arrowHead1.set({ left: line.x1, top: line.y1, angle: angle - 90 });
//         arrowHead2.set({ left: pointer.x, top: pointer.y, angle: angle + 90 });

//         fabricCanvas.requestRenderAll();
//     });

//     fabricCanvas.on('mouse:up', () => {
//         mouseDown = false;

//         // Convert line and arrowheads to a single group for easier manipulation
//         const objects = [line, arrowHead1, arrowHead2];
//         const group = new fabric.Group(objects, {
//             subTargetCheck: true,
//         });

//         fabricCanvas.remove(line, arrowHead1, arrowHead2);
//         fabricCanvas.add(group);
//     });
// };

// export default lineArrowLeftRight;

// const lineArrowLeftRight = (fabricCanvas, fabric) => {
//     let line, arrowHead1, arrowHead2, isDrawing = false;

//     fabric.Object.prototype.controls.customControl = new fabric.Control({
//         positionHandler: controlPositionHandler,
//         actionHandler: anchorWrapper(0, actionHandler),
//         actionName: 'modifyArrow',
//         render: renderCustomControl,
//     });

//     function controlPositionHandler(dim, finalMatrix, fabricObject) {
//         let x = (fabricObject.x1 + fabricObject.x2) / 2,
//             y = (fabricObject.y1 + fabricObject.y2) / 2;
//         return fabric.util.transformPoint({ x, y }, finalMatrix);
//     }

//     function actionHandler(eventData, transform, x, y) {
//         let arrow = transform.target,
//             currentControl = arrow.controls[arrow.__corner],
//             mouseLocalPosition = arrow.toLocalPoint(new fabric.Point(x, y), 'center', 'center'),
//             mouseLocalX = mouseLocalPosition.x * arrow.scaleX,
//             mouseLocalY = mouseLocalPosition.y * arrow.scaleY;
//         arrow.set({
//             x1: currentControl.x1Multiplier === 1 ? mouseLocalX : arrow.x1,
//             y1: currentControl.y1Multiplier === 1 ? mouseLocalY : arrow.y1,
//             x2: currentControl.x2Multiplier === 1 ? mouseLocalX : arrow.x2,
//             y2: currentControl.y2Multiplier === 1 ? mouseLocalY : arrow.y2,
//         });
//         return true;
//     }

//     function renderCustomControl(ctx, left, top, styleOverride, fabricObject) {
//         const size = this.cornerSize;
//         ctx.save();
//         ctx.fillStyle = '#ff0000';
//         ctx.beginPath();
//         ctx.arc(left, top, size, 0, 2 * Math.PI, false);
//         ctx.fill();
//         ctx.restore();
//     }

//     fabricCanvas.on('mouse:down', (o) => {
//         if (!fabricCanvas.isDrawingLineArrowLeftRightMode) return;
//         isDrawing = true;
//         let pointer = fabricCanvas.getPointer(o.e);
//         line = new fabric.Line([pointer.x, pointer.y, pointer.x, pointer.y], {
//             stroke: 'red',
//             strokeWidth: 3,
//             hasBorders: false,
//             hasControls: false,
//             lockMovementX: true,
//             lockMovementY: true,
//         });

//         fabricCanvas.add(line);
//         fabricCanvas.setActiveObject(line);
//     });

//     fabricCanvas.on('mouse:move', (o) => {
//         if (!isDrawing) return;
//         let pointer = fabricCanvas.getPointer(o.e);
//         line.set({ x2: pointer.x, y2: pointer.y });
//         fabricCanvas.requestRenderAll();
//     });

//     fabricCanvas.on('mouse:up', () => {
//         isDrawing = false;
//         addArrowHeads(line);
//     });

//     function addArrowHeads(line) {
//         arrowHead1 = new fabric.Triangle({
//             fill: 'red',
//             left: line.x1,
//             top: line.y1,
//             angle: calculateAngle(line.x1, line.y1, line.x2, line.y2) - 90,
//             originX: 'center',
//             originY: 'center',
//             width: 20,
//             height: 20,
//             selectable: false,
//         });

//         arrowHead2 = new fabric.Triangle({
//             fill: 'red',
//             left: line.x2,
//             top: line.y2,
//             angle: calculateAngle(line.x1, line.y1, line.x2, line.y2) + 90,
//             originX: 'center',
//             originY: 'center',
//             width: 20,
//             height: 20,
//             selectable: false,
//         });

//         fabricCanvas.add(arrowHead1, arrowHead2);
//         line.customControls = { customControl: true };
//         fabricCanvas.setActiveObject(line);
//     }

//     function calculateAngle(x1, y1, x2, y2) {
//         return Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI;
//     }
// };

// export default lineArrowLeftRight;
// const lineArrowLeftRight = (fabricCanvas, fabric) => {
//     let line, arrowHead1, arrowHead2, isDrawing = false;

//     // Define a simple circle control
//     const circleControl = {
//         radius: 5,
//         fill: 'red',
//         visible: true,
//         render: function(ctx, left, top, line) {
//             ctx.save();
//             ctx.fillStyle = this.fill;
//             ctx.beginPath();
//             ctx.arc(left, top, this.radius, 0, 2 * Math.PI);
//             ctx.fill();
//             ctx.restore();
//         }
//     };

//     // Add the control to both ends of the line
//     fabric.Line.prototype.controls = {
//         start: circleControl,
//         end: circleControl
//     };

//     fabricCanvas.on('mouse:down', (o) => {
//         if (!fabricCanvas.isDrawingLineArrowLeftRightMode) return;
//         isDrawing = true;
//         const pointer = fabricCanvas.getPointer(o.e);
//         line = makeLine([pointer.x, pointer.y, pointer.x, pointer.y]);
//         fabricCanvas.add(line);
//     });

//     fabricCanvas.on('mouse:move', (o) => {
//         if (!isDrawing) return;
//         const pointer = fabricCanvas.getPointer(o.e);
//         line.set({ x2: pointer.x, y2: pointer.y });
//         fabricCanvas.requestRenderAll();
//     });

//     fabricCanvas.on('mouse:up', () => {
//         isDrawing = false;
//         addArrowHeads(line);
//     });

//     function makeLine(coords) {
//         return new fabric.Line(coords, {
//             fill: 'red',
//             stroke: 'red',
//             strokeWidth: 5,
//             selectable: true,
//             hasBorders: false,
//             hasControls: false,
//             evented: true
//         });
//     }

//     function addArrowHeads(line) {
//         const angle = calculateAngle(line.x1, line.y1, line.x2, line.y2);
//         arrowHead1 = makeArrowHead(line.x1, line.y1, angle - 90);
//         arrowHead2 = makeArrowHead(line.x2, line.y2, angle + 90);

//         fabricCanvas.add(arrowHead1, arrowHead2);
//     }

//     function makeArrowHead(left, top, angle) {
//         return new fabric.Triangle({
//             left: left,
//             top: top,
//             fill: 'red',
//             width: 20,
//             height: 20,
//             angle: angle,
//             originX: 'center',
//             originY: 'center',
//             selectable: false
//         });
//     }

//     function calculateAngle(x1, y1, x2, y2) {
//         return Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI;
//     }

//     // Update the positions of the arrowheads when the line is moved or modified
//     fabricCanvas.on('object:modified', function(e) {
//         const line = e.target;
//         if (line) {
//             const angle = calculateAngle(line.x1, line.y1, line.x2, line.y2);
//             arrowHead1.set({ left: line.x1, top: line.y1, angle: angle - 90 });
//             arrowHead2.set({ left: line.x2, top: line.y2, angle: angle + 90 });
//             fabricCanvas.renderAll();
//         }
//     });
// };

// export default lineArrowLeftRight;
